<div class="bg-white">
  <div class="flex pb-5 px-3 m-auto pt-5 text-gray-800 text-sm flex-col
     md:flex-row max-w-6xl">
     <div class="mt-2">© Copyright 2020. All Rights Reserved.</div>
     
  </div>
</div>